@use "src/styles/common/_colors.scss";
.tbody {
    tr {
        td {
            border-top: none;
            font-size: 11px;
            line-height: 16px;
            font-weight: normal;
            cursor: default;
            padding: 0.5rem;
            &.center {
                text-align: center;
            }
             border-bottom: 0;
             border-right-color: colors.$black;
             border-right-style: solid;
             border-left:1px solid colors.$gray-variant-4;
             border-top: 1px solid colors.$black;
            a{
                color:inherit;
            }
        }
        
    }
}

.tbodyHover{
    tr{

        &:hover > td {
            text-decoration: none;
            background: colors.$report-dialog-pabel-color;
            color: colors.$white;
            cursor: pointer;
        }
    }
}

.tdEllipses {
    word-break: keep-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
}

.noRecords {
    position: relative;
    td {
        text-align: center;
        width: 100%;
        border-right: 1px solid colors.$black;
    }
}
